/* eslint-disable @typescript-eslint/naming-convention */
import 'reflect-metadata';
import {FormElement, FormElementConfiguration} from 'app/entities/form/formElement.entity';
import {Type} from 'class-transformer';
import {Dictionary} from 'app/entities/dictionary.entity';
import {SwitchRadioCollection} from 'app/entities/switchCollection.entity';
import {FormElementType} from 'app/entities/enums';

export class FormElementRadio extends FormElement {
  type: FormElementType = 'radio';

  @Type(() => FormElementRadioConfiguration)
  configuration?: FormElementRadioConfiguration = new FormElementRadioConfiguration();
}

export class FormElementRadioConfiguration extends FormElementConfiguration {
  dictionaryCode?: string = null;

  @Type(() => Dictionary)
  dictionaryList?: Dictionary[] = [];

  getListCollection?() {
    return new SwitchRadioCollection(this.dictionaryList.map((item) => item.getSwitchItem()));
  }
}
